import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  br: {
    marginVertical: 10,
    borderTop: 0.5,
    borderColor: '#6c757d',
  },
});

const Break = () => <View style={styles.br} />;

export default Break;
